module.exports = __webpack_public_path__ + "static/media/cropped-screen.a6343b03.svg";